import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import utils from '../utils'
import { Link } from 'react-router-dom';
import { 
  LuHome, 
  LuCompass as LuDraftingCompass, 
  LuConstruction, 
  LuHardHat, 
  LuTriangle,
  LuAlertTriangle 
} from "react-icons/lu";
import img from '../assets/404.png'

const Error404 = () => {
  return (
    <main className=" flex items-center justify-center pt-10 pb-20 px-6 bg-surface-container-lowest">
      <div className="container mx-auto w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        
        <div className="order-2 md:order-1 text-center md:text-left space-y-8">
          <div className="space-y-2">
            <h1 className="text-8xl md:text-9xl font-headline font-black text-primary leading-none tracking-tighter">
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-headline font-bold text-on-surface tracking-tight">
              Looks like this blueprint is missing.
            </h2>
            <p className="text-on-surface-variant max-w-md mx-auto md:mx-0 leading-relaxed">
              The page you are looking for has been moved, demolished, or is still under construction. Let's get your project back on track.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Link 
              to="/" 
              className="bg-primary text-white px-8 py-4 rounded-xl font-bold shadow-lg hover:bg-primary/90 transition-all active:scale-95 flex items-center justify-center gap-2"
            >
              <LuHome size={20} />
              Return Home
            </Link>
            <Link 
              to="/houses" 
              className="bg-surface-container text-primary px-8 py-4 rounded-xl font-bold border border-outline-variant hover:bg-surface-variant transition-all active:scale-95 flex items-center justify-center gap-2"
            >
              <LuDraftingCompass size={20} />
              Browse House Plans
            </Link>
          </div>

          <div className="pt-8 grid grid-cols-3 gap-4 opacity-50 grayscale">
            <div className="flex flex-col items-center md:items-start gap-1">
              <LuTriangle className="text-primary" />
              <span className="text-[10px] font-bold uppercase tracking-widest">Foundation</span>
            </div>
            <div className="flex flex-col items-center md:items-start gap-1">
              <LuConstruction className="text-primary" />
              <span className="text-[10px] font-bold uppercase tracking-widest">Framing</span>
            </div>
            <div className="flex flex-col items-center md:items-start gap-1">
              <LuDraftingCompass className="text-primary" />
              <span className="text-[10px] font-bold uppercase tracking-widest">Finish</span>
            </div>
          </div>
        </div>

        <div className="order-1 md:order-2 relative">
          <div className="absolute inset-0 bg-primary/5 rounded-full blur-3xl transform -translate-y-12"></div>
          
          <div className="relative bg-white rounded-2xl shadow-2xl border border-outline-variant/30 p-2 transform rotate-2">
            <div className="aspect-square bg-surface-container-low rounded-xl overflow-hidden relative group">
              <img 
                src={img}
                alt="Architectural Blueprint 404" 
                className="w-full h-full object-cover opacity-80"
              />

              <div className="absolute inset-0 flex items-center justify-center bg-primary/20 backdrop-blur-[2px]">
                <div className="bg-white/90 backdrop-blur-md p-8 rounded-3xl shadow-2xl text-center border border-primary/10 max-w-[80%]">
                  <LuAlertTriangle className="text-6xl text-primary mb-4 mx-auto" />
                  <p className="font-headline font-black text-primary uppercase tracking-widest text-sm">Site Restricted</p>
                  <div className="mt-2 h-1.5 w-12 bg-primary mx-auto rounded-full"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute -bottom-6 -left-6 bg-white p-5 rounded-2xl shadow-2xl border border-outline-variant/30 hidden lg:block z-20">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <LuHardHat className="text-primary text-2xl" />
              </div>
              <div>
                <p className="text-[10px] font-bold uppercase text-on-surface-variant tracking-widest">Project Status</p>
                <p className="text-sm font-black text-error">Incomplete</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </main>
  );
};


function PageNotFound() {
    return (
        <HelmetProvider>
            <Helmet>
                <title>Page Not Found - {utils.siteName}</title>
            </Helmet>
            <Error404/>
        </HelmetProvider>
    )
}

export default PageNotFound